<template>
  <div class="account-appeal-index">
    <van-form class="second-phone-form">
      <van-field
        class="from-field-phone"
        v-model="phoneNumber"
        label="更换绑定手机号码"
        label-width="3.5rem"
        type="tel"
        name="phoneReg"
        maxlength="11"
        placeholder="请输入手机号码"
        :rules="[
          { required: true, message: '请输入正确手机格式', pattern: phoneReg },
        ]"
        clearable
      />
      <van-field
        class="from-field-phone"
        v-model="verifycode"
        name="smsCode"
        label="验证码"
        type="digit"
        label-width="3.5rem"
        clearable
        maxlength="6"
        placeholder="请输入短信验证码"
        :rules="[{ required: true, message: '请输入短信验证码' }]"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="sendCode"
            v-if="codeShow"
            :text="getCodeText"
          >
          </van-button>
          <van-button size="small" type="info" @click="toastWait" v-else
            >{{ count }} s</van-button
          >
        </template>
      </van-field>
    </van-form>
    <div class="from-button">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        :disabled="isCanNext"
        @click="next"
      >
        下一步
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { encryptByAES, encryptKey } from "../../api/encryption";
export default {
  data() {
    return {
      phoneNumber: "",
      verifycode: "",
      getCodeText: "获取验证码",
      codeShow: true,
      count: 60,
      loginName: "",
      phoneReg:
        /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/,
    };
  },
  computed: {
    isCanNext() {
      return this.phoneNumber && this.verifycode ? false : true;
    },
    ...mapGetters({ getidcard: "idcard" }),
  },
  created() {},
  methods: {
    toastWait() {
      this.$toast("请" + this.count + "秒后点击获取！");
    },
    sendCode() {
      var self = this;
      const TIME_COUNT = 60;
      self.getCodeText = "发送中...";
      // this.JSBridge.showLoading("数据加载中..");
      // 调用发短信接口
      // this.$axios({
      //     url: "/vi/findPsnInfoByIdCardStepThree",
      //     method: "post",
      //     data: {
      //         mobilePhone: this.phoneNumber,
      //         smsTemType: "55"
      //     }
      // this.JSBridge.requestRpc({
      //     url: "com.abchina.xyl.findPsnInfoByIdCardStepThree",
      //     params: {
      //         mobilePhone: this.phoneNumber,
      //         smsTemType: "55"
      //     }
      this.request({
        url: "/sga/user/findPsnInfoByIdCardStepThree",
        type: "post",
        params: {
          mobilePhone: encryptByAES(this.phoneNumber, encryptKey),
          smsTemType: "55",
        },
      })
        .then((res) => {
          this.JSBridge.hideLoading();
          console.log("发送成功", res);
          let { respCode, respMsg, sgasession } = res;
          if (respCode !== "00000000") {
            this.getCodeText = "获取验证码";
            this.$toast(respMsg);
          } else {
            this.$toast("短信发送成功");
            // 成功
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeShow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
              this.getCodeText = "重新获取验证码";
            }
          }
        })
        .then((err) => {
          this.JSBridge.hideLoading();
          console.log("err", err);
        });
    },
    next() {
      let loginName = this.getidcard;
      let smsCode = this.verifycode;
      if (smsCode.length != 6) {
        return this.$toast("请输入正确的验证码");
      }
      // this.JSBridge.showLoading("数据加载中..");
      // this.$axios({
      //     url: "/vi/findPsnInfoByIdCardStepFour",
      //     method: "post",
      //     data: {
      //         mobilePhone: this.phoneNumber,
      //         loginName,
      //         smsCode
      //     }
      // this.JSBridge.requestRpc({
      //     url: "com.abchina.xyl.findPsnInfoByIdCardStepFour",
      //     params: {
      //         mobilePhone: this.phoneNumber,
      //         loginName,
      //         smsCode
      //     }
      this.request({
        url: "/sga/user/findPsnInfoByIdCardStepFour",
        type: "post",
        params: {
          mobilePhone: encryptByAES(this.phoneNumber, encryptKey),
          loginName: encryptByAES(loginName, encryptKey),
          smsCode,
        },
      })
        .then((res) => {
          // console.log(res);
          this.JSBridge.hideLoading();
          if (res.respCode == "00000000") {
            this.$router.push({
              path: "/accountAppeal/fifthResetPwd",
              query: { sendMessageNo: this.phoneNumber },
            });
          } else {
            this.$toast(res.respMsg);
          }
        })
        .catch((error) => {
          this.JSBridge.hideLoading();
          console.log(error);
        });
    },
  },
};
</script>

<style scoped lang="less">
.second-phone-form {
  padding-top: 10px;
}
.from-field-phone {
  font-size: 0.4rem;
  padding: 15px 10px;
  line-height: 25px;
  box-sizing: border-box;
}
.from-button {
  width: 86%;
  margin-left: 7%;
  border-radius: 5px;
  margin-bottom: 30px;
  button {
    border-radius: 3px;
    margin-top: 40px;
    height: 50px;
  }
}
.there-list ul {
  padding: 20px 0px;
  li {
    width: 100%;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    div {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 20px;
      position: relative;
      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 1.5rem;
        opacity: 0;
      }
    }
  }
}
.there-list {
  width: 100%;
  display: block;
  background-color: #ffffff;
  margin-top: 10px;
  padding: 10px 15px;
  p {
    font-size: 0.47rem;
    font-weight: 600;
    color: #333333;
    letter-spacing: 1px;
  }
  img {
    width: 40%;
  }
  span {
    width: 60%;
    line-height: 18px;
    display: block;
    font-size: 0.36rem;
    /*word-wrap:break-word;*/
    word-break: break-all;
    padding-left: 10px;
    box-sizing: border-box;
    color: #999999;
  }
}

.there-phone-btn-list {
  width: 100%;
  background-color: #ffffff;
  margin-top: 10px;
  padding: 10px;
  box-sizing: border-box;
  ul {
    width: 100%;
    li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      background-color: red;
      &:last-child span {
        position: absolute;
        right: 10px;
        top: 12px;
        font-size: 0.35rem;
        color: #3ca3ee;
        border: thin solid #3ca3ee;
        padding: 10px;
        border-radius: 3px;
        letter-spacing: 1px;
      }
      label {
        flex: 2;
      }
      input {
        flex: 6;
        display: inline-block;
      }
    }
  }
}
</style>
